import moment from "moment"
import 'moment/locale/fr';

export const fromNow = (date: string | Date) => {
    return moment(date).locale('fr').fromNow()
}